;(() => {
    window.RO = {}
    RO.classes = {}

    require('./utils/ro-only-numbers')

    require('./classes/ro-utils')
    
    require('./classes/ro-countdown')

    require('./components/ro-input-char-limiter')
    require('./components/ro-select')

})();
